import { render, staticRenderFns } from "./authentification.vue?vue&type=template&id=27bfbb72&"
import script from "./authentification.vue?vue&type=script&lang=js&"
export * from "./authentification.vue?vue&type=script&lang=js&"
import style0 from "./authentification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports